import {addDays, addMonths, endOfDay, isBefore} from 'date-fns';

export const isDateExpired = (date: Date | number | string): boolean => {
  const todayEnd = endOfDay(new Date());
  const expiresAt = endOfDay(new Date(date));
  return isBefore(expiresAt, todayEnd);
};

export const isDateBeforeInterval = (date: Date | number | string, interval: { days?: number; months?: number }): boolean => {
  const now = new Date();
  let compareDate = now;
  if(interval.days) {
    compareDate = addDays(compareDate, interval.days);
  }
  if(interval.months) {
    compareDate = addMonths(compareDate, interval.months);
  }
  const targetDate = new Date(date);
  return isBefore(targetDate, compareDate);
};
